import React from 'react';
import { css } from 'linaria';
import { Layout } from 'fronton-react';
import { HeaderGifStructure, HeaderSection, RootLayout, OtherSection } from 'common/components';
import { DesignStudioBenefits, DesignStudioGallery } from './components';
import {
  DESIGN_STUDIO_PATH,
  DESIGN_STUDIO_ELEMENT_BLOCK,
  DESIGN_STUDIO_LANDING_NAME,
} from './design-studio-constants';

const designStudioHeader = css`
  && img {
    @media (--only-tablet) {
      height: 62.5vw;
    }

    @media (--only-mobile) {
      height: 80vw;
    }
  }

  && h1 {
    @media (--only-tablet) {
      width: 350px;
    }
  }
`;

/**
 * Вью страницы "Студия дизайна"
 */
export const DesignStudio: React.FC = () => (
  <RootLayout currentPage={DESIGN_STUDIO_PATH}>
    <HeaderSection
      bgColor="#4C9393"
      description={`Сделаем дизайн-проект, рассчитаем материалы, сопроводим от\u00A0идеи до\u00A0покупки всех товаров.\nНаличие услуги уточняйте в\u00A0наших магазинах.`}
      img={
        {
          srcSet: `https://cdn.lemanapro.ru/lmru/image/upload/f_auto,c_pad,b_auto,d_photoiscoming.png/fudzi/elbrus/images/landings/design-studio/header/header-2.gif/header-2.gif`,
          title: 'Студия дизайна Лемана ПРО',
          alt: 'Студия дизайна Лемана ПРО',
        } as HeaderGifStructure
      }
      title={`Студия дизайна Лемана\u00A0ПРО`}
      mediaType="gif"
      containerClassname={designStudioHeader}
    />
    <Layout>
      <DesignStudioBenefits />
      <DesignStudioGallery />
    </Layout>
    <OtherSection
      elementBlock={`${DESIGN_STUDIO_ELEMENT_BLOCK} / other`}
      landingName={DESIGN_STUDIO_LANDING_NAME}
      promotionName={`${DESIGN_STUDIO_ELEMENT_BLOCK}_bottom`}
    />
  </RootLayout>
);
